import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import ProgressBar, { PROGRESS_BAR_THIN } from '@divvy-web/skylab.progressbar'

import DocumentUploadItem from '@sputnik/pages/DashboardPages/CreditApplicationsDataGrid/DashboardDetailsDrawer/DocumentsTabContent/DocumentUploadItem'
import { GetCreditApplicationDetails_creditApplication_CreditApplication_requiredDocs_CreditApplicationDocument } from '@sputnik/pages/DashboardPages/CreditApplicationsDataGrid/DashboardDetailsDrawer/GetCreditApplicationDetails.gql'

import styles from './styles.module.scss'

type CreditApplicationDocument =
  GetCreditApplicationDetails_creditApplication_CreditApplication_requiredDocs_CreditApplicationDocument

export interface RequiredDocumentsSectionProps {
  salesforceCreditId: string
  requiredDocuments: CreditApplicationDocument[]
}

const RequiredDocumentsSection = ({ salesforceCreditId, requiredDocuments }: RequiredDocumentsSectionProps) => {
  const [getClassName] = useNameFormatter('RequiredDocumentsSection')

  // TODO: when we get the graphql resolvers updated, update this to account for
  // the actual mechanism we will use to know uploaded doc status
  const totalDocumentsUploaded = requiredDocuments.reduce(
    (prev, curr) => (curr.statusMessage !== 'not-uploaded' ? ++prev : prev),
    0,
  )
  const totalDocumentsRequested = requiredDocuments.length

  return (
    <div className={styles[getClassName('')]}>
      <div className={styles[getClassName('title')]}>
        <div className={styles[getClassName('title-text')]}>
          <FormattedMessage
            defaultMessage='Required documents'
            id='sputnik.RequiredDocumentsSection__Lrm5gs'
          />
        </div>
        <ProgressBar
          currentStep={totalDocumentsUploaded}
          totalSteps={totalDocumentsRequested}
          type={PROGRESS_BAR_THIN}
        />
        <div className={styles[getClassName('title-progress-label')]}>
          <FormattedMessage
            defaultMessage='{totalUploaded} of {totalRequested} uploaded'
            id='sputnik.RequiredDocumentsSection__fN47Gm'
            values={{
              totalUploaded: totalDocumentsUploaded,
              totalRequested: totalDocumentsRequested,
            }}
          />
        </div>
      </div>
      {requiredDocuments.map((doc) => (
        <DocumentUploadItem
          key={doc.documentUuid}
          document={doc}
          salesforceCreditId={salesforceCreditId}
        />
      ))}
    </div>
  )
}

export default RequiredDocumentsSection
